import { ErrorPage } from '@/components/errors';

/**
 * 500 Internal Error Page
 *
 * Displayed when an unexpected server error occurs.
 * Provides retry and navigation options for recovery.
 */
export function InternalErrorPage() {
  const handleRetry = () => {
    // Attempt to retry by navigating back and refreshing
    window.history.back();
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <ErrorPage
      code={500}
      title="Something went wrong"
      message="We encountered an unexpected error. Our team has been notified and is working on a fix."
      showRetry
      onRetry={handleRetry}
      showReload
      onReload={handleReload}
      showHomeLink
      showDashboardLink
    />
  );
}

export default InternalErrorPage;
